export type DefaultValues = {
    [key: string]: string;
} & Record<any, any>;

/**
 * Embed a Nutshell Form inside of the Nutshell App :inception:
 *
 *
 * Example usage:
 * const FORM_ID = 'FrE6kq';
 *
 * React.useEffect(() => { useNutshellFormEmbed(FORM_ID); }, []);
 *
 * ...
 * <div styleName='form-container' id={`nutshell-form-${FORM_ID}`} />
 *
 * @return void
 */
export function initializeEmbeddedNsFormById(formId: string, defaultValues?: DefaultValues) {
    setTimeout(() => {
        const nutshellerScript = document.createElement('script');
        nutshellerScript.src = 'https://loader.nutshell.com/nutsheller.js';
        nutshellerScript.async = true;

        const defaultValuesStringified = JSON.stringify(defaultValues || {});

        const formScript = document.createElement('script');
        formScript.innerHTML = `(function(n,u,t){n[u]=n[u]||function(){(n[u].q=n[u].q||[]).push(arguments)}}(window,'Nutsheller'));
    Nutsheller('initForm', {form: '${formId}', instance: '4', target: 'nutshell-form-${formId}', defaultValues: ${defaultValuesStringified}});`;

        if (document.body) {
            const documentBody = document.body;
            documentBody.appendChild(formScript);
            documentBody.appendChild(nutshellerScript);
        }
    }, 100);
}
